import { graphql } from '@/gql';
import { type UpdateOperatorMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateOperator = async (id: UpdateOperatorMutationVariables['id'], data: any) => {
  return mutationExecute({
    variables: { data, id },
    mutation: graphql(`
      mutation UpdateOperator($data: OperatorInputType!, $id: String!) {
        updateOperator(data: $data, id: $id) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          registrationCallPriorityOverride
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
          regCallAudio
          resignationReason
          isVerified
        }
      }
    `),
  });
};
